module.exports = __webpack_public_path__ + "img/background-1.5f83821b.jpg";